import { SELECT_DAY } from 'redux/consts/selectedDay';

export function selectDay({ patientProviderId, selectedDay }) {
  return {
    type: SELECT_DAY,
    patientProviderId,
    selectedDay,
  };
}
